import {getSlugValue} from 'utilities/getSlugValue';

export const CONFIRMATION_DIALOG_TEST_IDS = {
  action: (label: string) => `confirmation-dialog__${getSlugValue(label)}`,
} as const;
